<template>
    <div class="password-section pa-2 pa-md-3 d-flex flex-column justify-center">
        <!-- User Profile Section -->
        <div class="profile-card mx-auto mb-3">
            <v-avatar 
                size="60" 
                class="profile-avatar mx-auto"
                style="background: linear-gradient(135deg, #2553b9 0%, #1e88e5 100%); box-shadow: 0 3px 15px rgba(37, 83, 185, 0.3); border: 3px solid white;">
                <v-icon :style="{ color: 'white', fontSize: '28px' }">fa:fa-solid fa-user</v-icon>
            </v-avatar>
            
            <div class="text-center" style="margin-top: 0.75rem;">
                <h3 style="color: #2553b9; font-size: 1rem; font-weight: 700; margin-bottom: 4px;">
                    {{ capitalizeWords(datauserregister.nombres + ' ' + datauserregister.apellidos) }}
                </h3>
                <p style="color: #757575; font-size: 0.8rem; margin-bottom: 8px;">
                    <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-envelope</v-icon>
                    {{ datauserregister.email }}
                </p>
                <v-chip 
                    color="success" 
                    variant="tonal" 
                    size="x-small">
                    <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-check-circle</v-icon>
                    Verificado
                </v-chip>
            </div>
        </div>

        <!-- Password Form Section -->
        <v-col cols="12" sm="10" md="8" lg="7" xl="6" class="mx-auto px-2">
            <v-card 
                elevation="0" 
                class="password-card pa-3"
                style="background: rgba(37, 83, 185, 0.03); border: 2px solid rgba(37, 83, 185, 0.1); border-radius: 12px;">
                
                <div class="text-center mb-3">
                    <v-icon :style="{ color: '#2553b9', fontSize: '28px', marginBottom: '6px' }">fa:fa-solid fa-key</v-icon>
                    <h4 style="color: #2553b9; font-size: 1rem; font-weight: 700; margin-bottom: 4px;">Configura tu contraseña</h4>
                    <p style="color: #757575; font-size: 0.75rem;">
                        Crea una contraseña segura
                    </p>
                </div>

                <v-form v-model="formvalidate">
                    <v-col cols="12" class="px-0">
                        <label class="field-label" style="margin-bottom: 4px;">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-lock</v-icon>
                            Nueva contraseña
                        </label>
                        <v-text-field 
                            :type="hidepass1 ? 'password' : 'text'" 
                            variant="outlined" 
                            density="compact"
                            hide-details="auto" 
                            :rules="[rules.required]" 
                            v-model="updatePassword.newpass"
                            class="modern-password-input"
                            placeholder="Ingresa tu contraseña">
                            <template v-slot:prepend-inner>
                                <v-icon :style="{ color: '#2553b9', fontSize: '16px' }">fa:fa-solid fa-lock</v-icon>
                            </template>
                            <template v-slot:append-inner>
                                <v-icon 
                                    @click="hidepass1 = !hidepass1"
                                    :style="{ color: '#757575', fontSize: '18px', cursor: 'pointer' }">
                                    {{ hidepass1 ? 'fa:fa-solid fa-eye' : 'fa:fa-solid fa-eye-slash' }}
                                </v-icon>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" class="px-0">
                        <label class="field-label" style="margin-bottom: 4px;">
                            <v-icon :style="{ fontSize: '12px', marginRight: '4px' }">fa:fa-solid fa-lock</v-icon>
                            Confirmar contraseña
                        </label>
                        <v-text-field 
                            :type="hidepass2 ? 'password' : 'text'" 
                            variant="outlined" 
                            density="compact"
                            hide-details="auto" 
                            :rules="[rules.required, validatePassword(updatePassword.newpass, updatePassword.confirmpass)]" 
                            v-model="updatePassword.confirmpass"
                            class="modern-password-input"
                            placeholder="Confirma tu contraseña">
                            <template v-slot:prepend-inner>
                                <v-icon :style="{ color: '#2553b9', fontSize: '16px' }">fa:fa-solid fa-lock</v-icon>
                            </template>
                            <template v-slot:append-inner>
                                <v-icon 
                                    @click="hidepass2 = !hidepass2"
                                    :style="{ color: '#757575', fontSize: '18px', cursor: 'pointer' }">
                                    {{ hidepass2 ? 'fa:fa-solid fa-eye' : 'fa:fa-solid fa-eye-slash' }}
                                </v-icon>
                            </template>
                        </v-text-field>
                    </v-col>

                    <!-- Password Requirements -->
                    <v-col cols="12" class="px-0 mt-2">
                        <v-alert 
                            density="compact" 
                            type="info" 
                            variant="tonal"
                            style="font-size: 0.75rem;">
                            <div class="d-flex align-center">
                                <v-icon :style="{ fontSize: '14px', marginRight: '6px' }">fa:fa-solid fa-info-circle</v-icon>
                                <span>Tu contraseña debe ser segura</span>
                            </div>
                        </v-alert>
                    </v-col>

                    <v-col cols="12" class="px-0 mt-3">
                        <v-btn 
                            @click="updatePassInvitado()" 
                            :loading="loadingUpdatePass" 
                            :disabled="!formvalidate" 
                            color="primary"
                            size="default"
                            block 
                            elevation="0"
                            style="font-weight: 700;">
                            <v-icon :style="{ fontSize: '16px', marginRight: '6px' }">fa:fa-solid fa-right-to-bracket</v-icon>
                            Iniciar Sesión
                        </v-btn>
                    </v-col>
                </v-form>
            </v-card>
        </v-col>
    </div>
</template>


<script>
import Filters from '@/modules/Shared/Filters';

import { mapState, mapActions } from 'vuex';

export default {
    mixins:[Filters],
    data()
    {
        return{
            hidepass1:true,
            hidepass2:true,
            formvalidate: true
        }
    },
    computed:
    {
        ...mapState('login', ['datauserregister', 'updatePassword', 'loadingUpdatePass'])
    },

    methods:{
        ...mapActions('login', ['updatePassInvitado'])
    }
}
</script>

<style scoped>
.password-section {
    animation: fadeIn 0.4s ease-out;
    min-height: 300px;
}

.profile-card {
    max-width: 350px;
    animation: slideDown 0.4s ease-out;
}

.profile-avatar {
    animation: scaleIn 0.5s ease-out;
}

.password-card {
    animation: slideUp 0.4s ease-out 0.15s both;
}

.field-label {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 600;
    color: #424242;
}

.modern-password-input :deep(.v-field) {
    border-radius: 8px;
    transition: all 0.2s ease;
}

.modern-password-input :deep(.v-field:hover) {
    box-shadow: 0 1px 8px rgba(37, 83, 185, 0.12);
}

.modern-password-input :deep(.v-field--focused) {
    box-shadow: 0 2px 12px rgba(37, 83, 185, 0.18);
    border-color: #2553b9;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.85);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@media (max-width: 600px) {
    .password-section {
        min-height: 250px;
    }
}
</style>